import { useFormikContext } from 'formik'
import { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'

const GetFormDirtyValue = ({ setFormDirty, externalTeamLogo }) => {
  const formInfo = useFormikContext()
  const previousDirtyRef = useRef(formInfo.dirty)
  const previousExternalLogoRef = useRef(externalTeamLogo)

  useEffect(() => {
    const shouldBeDirty = externalTeamLogo ? true : formInfo.dirty

    // Only call setFormDirty if the value actually changed
    if (
      previousDirtyRef.current !== formInfo.dirty ||
      previousExternalLogoRef.current !== externalTeamLogo
    ) {
      setFormDirty(shouldBeDirty)
      previousDirtyRef.current = formInfo.dirty
      previousExternalLogoRef.current = externalTeamLogo
    }
  }, [formInfo.dirty, externalTeamLogo, setFormDirty])

  return null
}

GetFormDirtyValue.propTypes = {
  setFormDirty: PropTypes.func,
  externalTeamLogo: PropTypes.string,
}

export default GetFormDirtyValue
